import { Stack, Typography } from "@mui/material";

const SectionHeader = ({
  title,
  rightContent,
}: {
  title: string;
  rightContent?: React.ReactNode;
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 2,
        py: 1,
        bgcolor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      <Typography variant="h6" component="h2" fontWeight="bold">
        {title}
      </Typography>
      {rightContent}
    </Stack>
  );
};
export default SectionHeader;
